import React, { useContext } from "react";
import YouTube from "react-youtube";
import { LanguageContext, text } from "../../container/language";

const VideoPlayer = ({ data }) => {
  const { userLanguage } = useContext(LanguageContext);
  const { caption, url } = data;
  return (
    <p>
      <span contenteditable="false" class="mce-preview-object mce-object-iframe">
        <YouTube videoId={url.split("=")[1]} />
        <p style={{ marginTop: "5px" }}>
          <font>
            <em>{text(caption, userLanguage)}</em>
          </font>
        </p>
      </span>
    </p>
  );
};

export default VideoPlayer;
